import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

import type { Performance } from '../model/recital';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllPerformancesParams {
  actId: string;
  page?: number;
  limit?: number;
}

export const getAllPerformancesAPI = async ({
  actId,
  ...params
}: GetAllPerformancesParams) => {
  const response = await baseAPI.get<Array<Performance>>(
    `/acts/${actId}/performances`,
    {
      params,
    },
  );
  return response.data;
};

export const getAllPerformancesOptions = (params: GetAllPerformancesParams) => {
  return queryOptions({
    queryKey: [KEYS.ACTS, params.actId, KEYS.PERFORMANCES, params],
    queryFn: () => getAllPerformancesAPI(params),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetAllPerformances = (params: GetAllPerformancesParams) => {
  return useQuery(getAllPerformancesOptions(params));
};
